import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Workouts } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import TabComponent from "./TabComponent";

const useStyles = makeStyles((theme) => ({
  tablList: {
    "& .step-indicator": {
      width: "60%",
      textAlign: "center",
      marginTop: 15,
      // marginLeft: '31%',
      right: "90px",
      // position:"sticky",
      position: "absolute",
      [theme.breakpoints.down("md")]: {
        marginTop: 15,
        width: "100%",
        marginLeft: "0%",
        right: "unset",
      },
    },
    "& .action-group": {
      marginTop: -30,
      [theme.breakpoints.down("md")]: {
        marginTop: -35,
      },
      "& .MuiButton-root": {
        height: 40,
        width: 95,
        textTransform: "capitalize",
        color: "#ffffff",
        fontSize: 14,
        fontWeight: 600,
        "&.prev": {
          float: "left",
          backgroundColor: "#333333",
        },
        "&.next": {
          float: "right",
          backgroundColor: "var(--text-primary)",
        },
      },
    },
  },
}));

type TabListProps = {
  currentTab: number;
  supersetList?: Workouts.IExercise[] | null;
  addExercise?: Workouts.IExercise[] | null;
  handleAction: (e: React.MouseEvent) => false | void;
  children?: any;
};

const TabsList: React.FC<TabListProps> = ({
  currentTab,
  supersetList,
  addExercise,
  handleAction,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const exerciseList = [supersetList, addExercise].find((array) => Boolean(array));

  if (!exerciseList) {
    return <div id="tablist-container"></div>;
  }

  return (
    <div
      id="tablist-container"
      className={classes.tablList}
      style={{ width: window.innerWidth > 700 ? "48%" : "100%" }}
    >
      {exerciseList.map((exercise, exerciseIndex) => (
        <TabComponent
          key={exerciseIndex}
          exerciseIndex={exerciseIndex}
          currentTab={currentTab}
          exercise={exercise}
        />
      ))}
      {/* Step indicator */}
      <div className="step-indicator" id="setMarginTop">
        {currentTab ? (
          <>
            <span key={0} className="step" />
            {exerciseList.map((exercise, exerciseIndex) => (
              <span key={exerciseIndex + 1} className="step" />
            ))}
          </>
        ) : (
          <div style={{ marginTop: "40px" }} />
        )}
        {/* Action buttons Previous, Next/Submit */}
        <div
          className="action-group"
          // style={{width:window.innerWidth>700 ?"60%": "unset", marginLeft:window.innerWidth>700 ?"31%" :"0px"}}
        >
          <Button
            variant="contained"
            size="small"
            id="prevBtn"
            type="button"
            className="prev"
            onClick={handleAction}
          >
            {t("Previous")}
          </Button>
          <Button
            variant="contained"
            size="small"
            id="nextBtn"
            type="button"
            className="next"
            onClick={handleAction}
          >
            {t("Next")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TabsList;
